import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CeButtonComponent } from '@kempower-nx-workspace/shared/kp-design-system';
import { ReceiptLookupNavigationService } from '@kempower-nx-workspace/receipt-lookup-app-core';

@Component({
    selector: 'lib-not-found-receipt',
    imports: [CommonModule, CeButtonComponent],
    templateUrl: './not-found-receipt.component.html',
    styleUrl: './not-found-receipt.component.scss'
})
export class NotFoundReceiptComponent {
    readonly #navigation: ReceiptLookupNavigationService = inject(ReceiptLookupNavigationService);

    searchAgain() {
        this.#navigation.navigateToSearchRoot();
    }
}
